import React, { useEffect, useRef } from 'react';
import { MdClose } from 'react-icons/md';
import useClickOutside from '../../../hooks/useClickOutside';
import Portal from '../../ui/Portal';
import form from '../../../styles/shared/FormDialog.module.css';
import dialog from '../../../styles/shared/Dialog.module.css';

// Crear / editar taller. Estilos comunes en styles/shared/FormDialog.module.css (como el de usuarios):
// etiquetas visibles, campos de 48px y Cancelar | acción principal abajo.
const WorkshopModal = ({ isOpen, onClose, onSubmit, formValues, handleInputChange, isEditMode, formError }) => {
  const modalRef = useRef(null);

  useClickOutside(modalRef, onClose, isOpen);

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const title = isEditMode ? 'Editar taller' : 'Crear taller';

  return (
    <Portal>
      <div className={form.overlay}>
        <div
          className={form.content}
          ref={modalRef}
          role="dialog"
          aria-modal="true"
          aria-labelledby="workshop-modal-title"
        >
          <div className={form.header}>
            <h2 id="workshop-modal-title" className={form.formTitle}>{title}</h2>
            <button type="button" className={form.close} onClick={onClose} aria-label="Cerrar">
              <MdClose aria-hidden="true" />
            </button>
          </div>
          <form onSubmit={onSubmit} className={form.form}>
            <div className={form.field}>
              <label htmlFor="workshop-nombre" className={form.label}>Nombre</label>
              <input
                id="workshop-nombre"
                type="text"
                name="nombre"
                className={form.formInput}
                placeholder="Ej: Taller de escalada"
                maxLength={100}
                autoComplete="off"
                value={formValues.nombre}
                onChange={handleInputChange}
              />
            </div>
            <div className={form.field}>
              <label htmlFor="workshop-descripcion" className={form.label}>Descripción (opcional)</label>
              <textarea
                id="workshop-descripcion"
                name="descripcion"
                className={`${form.formInput} ${form.formTextarea}`}
                placeholder="Breve descripción del taller"
                rows={3}
                maxLength={100}
                aria-describedby="workshop-descripcion-hint"
                value={formValues.descripcion || ''}
                onChange={handleInputChange}
              />
              <p id="workshop-descripcion-hint" className={form.hint}>
                {(formValues.descripcion || '').length}/100 caracteres
              </p>
            </div>
            <div className={form.field}>
              <label htmlFor="workshop-fecha-inicio" className={form.label}>Fecha de inicio</label>
              <input
                id="workshop-fecha-inicio"
                type="date"
                name="fechaInicio"
                className={form.formInput}
                value={formValues.fechaInicio}
                onChange={handleInputChange}
              />
            </div>
            {formError && <p className={form.formError} role="alert">{formError}</p>}
            <div className={`${dialog.buttons} ${form.buttons}`}>
              <button type="button" className={dialog.cancelButton} onClick={onClose}>Cancelar</button>
              <button type="submit" className={dialog.confirmButton}>
                {isEditMode ? 'Guardar cambios' : 'Crear taller'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Portal>
  );
};

export default WorkshopModal;
